<template>
	<div>
		<van-swipe :autoplay="3000" ref="swipe" class="my-swipe" @change="change">
			<van-swipe-item v-for="(item, index) in data">
				<van-image class="swipe-img-item" :src="item" />
			</van-swipe-item>
			<template #indicator="{ active, total }">
				<div class="custom-indicator">{{ active + 1 }}/{{ total }}</div>
			</template>
		</van-swipe>
	</div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
	currentTeacher: {
		type: Object,
		default: () => ({}),
	},
});

const swipe = ref(null);
const current = ref(0);
watch(
	() => props.currentTeacher,
	val => {
		const index = props.data.findIndex(item => item.id === props.currentTeacher?.id);
		if (index === -1) return;
		if (current.value === index) return;
		swipe.value.swipeTo(index);
	}
);

const emits = defineEmits(["change"]);
const change = index => {
	current.value = index;
	emits("change", props.data[index]);
};
</script>

<style lang="scss" scoped>
.my-swipe {
	margin: -1px -1px 0;
	width: 750px;
	height: 566px;

	.swipe-img-item {
		width: 750px;
	}
	.custom-indicator {
		width: 48px;
		height: 36px;
		font-family: PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #ffffff;
		line-height: 36px;
		text-align: center;
		background: rgba(0, 0, 0, 0.65);
		border-radius: 18px 18px 18px 18px;
		position: absolute;
		right: 16px;
		bottom: 18px;
	}
}
</style>
